class Store {
  constructor() {
    this.__reduxStore = null;
    this.dispatch = this.dispatch.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.getState = this.getState.bind(this);
  }

  dispatch(action) {
    try {
      return this.__reduxStore.dispatch(action);
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  getState(...args) {
    return this.__reduxStore.getState(...args);
  }

  subscribe(...args) {
    return this.__reduxStore.subscribe(...args);
  }

  injectReduxStore(s) {
    this.__reduxStore = s;
  }
}

const store = new Store();
export default store;
